import { Alert } from 'lib/alert/models';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { STALE_TIME } from 'business/constants';

/**
 * Hook React Query to fetch an alert based on its id
 * @param {number} alertId - The id of the alert to be fetched
 */
export const useGetAlert = (alertId: number): UseQueryResult<Alert> =>
    useQuery({
        queryKey: ['alert', alertId],

        queryFn: async () => {
            const response = await RQAPICallWithData<Alert>({
                endpoint: `alert/${alertId}`,
                method: 'GET',
            });
            return response.content.data;
        },

        staleTime: STALE_TIME,
    });
